import { configurationSchema } from '@report/configuration';

export const configuration = configurationSchema.parse({
  mode: import.meta.env.MODE,
  logLevel: import.meta.env.VITE_LOG_LEVEL,
  graphql: {
    apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
    defaultFetchPolicy: import.meta.env.VITE_GRAPHQL_DEFAULT_FETCH_POLICY,
  },
  loginUrl: import.meta.env.VITE_LOGIN_URL,
  userSessionApiUrl: import.meta.env.VITE_USER_SESSION_API_URL,
});
